








import { Component, Vue, Prop } from 'vue-property-decorator'
import AppKBColCard from './AppKBColCard.vue'
import { KBCardStructure } from '../../model/structure/KBStructure'

@Component({
  components: {
    AppKBColCard
  }
})
export default class AppKBColCardList extends Vue {
  @Prop({ default: [] }) readonly cards: KBCardStructure[]
}
